import React from "react";
import { Nav } from "@caesars-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { setSemanticTheme, semanticThemeSelector } from "~/state/globalSlice";

const items = [
  {
    id: 0,
    label: "Caesars Light",
  },
  {
    id: 1,
    label: "Caesars Dark",
  },
  {
    id: 2,
    label: "William Hill Light",
  },
  {
    id: 3,
    label: "William Hill Dark",
  },
  {
    id: 4,
    label: "Caesars Palace Light",
  },
  {
    id: 5,
    label: "Caesars Palace Dark",
  },
];

const SemanticThemeSwitcher = ({ handleToggle, ...rest }) => {
  const dispatch = useDispatch();
  const platform = useSelector(semanticThemeSelector);
  const handleActiveItem = (id) => {
    const [selectedItem] = items.filter((i) => i.id === id);
    dispatch(setSemanticTheme(selectedItem.label));
  };
  const activeItem = items.filter((item) => item.label === platform)[0].id;
  return (
    <Nav
      items={items}
      initialActive={activeItem}
      onActiveItem={handleActiveItem}
      variant="pill"
      type="minimal"
      size="md"
      simple
      {...rest}
    />
  );
};

export default SemanticThemeSwitcher;
